import { AdminsApi } from "@/api/admins";
import { SetAdminStatusRequest } from "@/api/admins/types";
import { ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useSetAdminStatus = ({ closeMenu }: { closeMenu: () => void }) => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const { mutate: setAdminStatus } = useMutation({
    mutationFn: (body: SetAdminStatusRequest) => AdminsApi.setAdminStatus(body),
    onMutate: () => {
      closeMenu();
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ResourceName.ADMIN_USERS],
      });
      notify("Admin status updated!", { type: "success" });
    },
  });

  return {
    setAdminStatus,
  };
};
